<template>
  <div class="YuanAIBox">
    <div class="titleBox" style="margin-top: 1px">
      <img class="allImage" :src="firstPhoto" alt="" />
      <div class="ImgOrText">
        <p style="font-weight: bold">元宇宙</p>
        <p>
          作为元宇宙领域的深度耕耘者与先锋探索者，专注于挖掘元宇宙的多元潜力。凭借在人工智能、虚拟现实等关键技术上的深厚积累与创新应用
          为元宇宙的内容创作与交互体验精心雕琢。无论是定制化的虚拟场景构建，还是智能虚拟角色的开发，都彰显着我们对极致沉浸感与个性化的
          追求。我们致力于成为各行业与元宇宙融合的桥梁，助力教育跨越时空限制、文旅焕发全新魅力、商业开启创新模式，深度激活元宇宙在不同
          场景中的价值裂变，推动元宇宙从愿景逐步走向全方位的社会价值赋能，以技术与创意的双重力量重塑数字化未来的无限可能
        </p>
      </div>
      <div class="ImgOrText2">
        <p style="font-weight: bold">人</p>
        <p>
          我们为数字人设定了D1~D6等级，方便企业根据业务和场景的需要，量身定制3D数字人模型
        </p>
      </div>
      <div class="ImgOrText3">
        <p style="font-weight: bold">数字人分类：D1-D3</p>
      </div>
    </div>
    <div class="midBox">
      <ul>
        <li v-for="(v, k) in firstitems" :key="k">
          <p>{{ v.msg }}</p>
          <img :src="v.url" alt="" />
        </li>
      </ul>
    </div>
    <p class="ImgOrText4">数字人分类：D4-D6</p>
    <div class="midBox">
      <ul>
        <li v-for="(v, k) in imgList" :key="k">
          <p>{{ v.msg }}</p>
          <img :src="v.url" alt="" />
        </li>
      </ul>
    </div>
    <div class="midBox">
      <div class="ImgOrText5">
        <p style="font-weight: bold">物</p>
        <p>
          我们在数字化建模领域具备全方位的精湛技艺，可通过三维扫描、CAD、图片建模技术，精准还原物体的结构与细节，为客户提供高质量
          定制化的建模服务，满足不同行业在产品设计、文物修复、影视制作、建筑规划等多方面的多样化需求，能为多行业提供高质量定制化建
          模服务，助力客户在数字化进程里达成创意与项目的理想落地
        </p>
      </div>
    </div>
    <Carousel class="carousel"></Carousel>
    <div class="midBox">
      <img class="allImage" :src="changPhoto" alt="" />
      <div class="ImgOrText6">
        <p style="font-weight: bold">场</p>
        <p>
          公司致力于打造从设计到场景建模的一站式服务体系，将艺术美感与实用功能精妙融合，赋予每个场景灵动的生命力，将各类设计构想
          快速精准转化为三维模型，依托这一完整服务链条，能够广泛服务于游戏开发、影视制作、文化展览、商业营销等诸多领域
        </p>
      </div>
    </div>
    <div class="midBox">
      <div class="ImgOrText5">
        <p style="font-weight: bold">经</p>
        <p>
          在元宇宙的宏大架构中，经济系统的构建堪称核心枢纽，从设计独特的数字货币，确保其安全、稳定的发行与流通机制，到构建多样化
          的交易市场满足虚拟资产的高效交换与价值发现需求，推动系统发展，赋能元宇宙价值创造与交互
        </p>
      </div>
    </div>
    <div class="midBox">
      <img class="allImage sw" :src="jingPhoto" alt="" />
    </div>
    <div class="midBox">
      <div class="ImgOrText5">
        <p style="font-weight: bold">界</p>
        <p>
          在元宇宙方面拥有强大的世界观构建实力，深度雕琢其架构，涵盖时空、种族文明与规则设定，再精准具象化呈现，从地貌到角色
          皆依世界观构建，打造沉浸式世界
        </p>
      </div>
    </div>
    <div class="midBox">
      <div class="setAllBox" v-for="(v, k) in footerList" :key="k">
        <div class="por">
          <img
            class="allImage"
            style="height: 100%; overflow: hidden"
            :src="v.src"
            alt=""
          />
        </div>
        <div class="por" style="margin-right: 0px">
          <img
            class="allImage"
            style="height: 100%; overflow: hidden"
            :src="v.otherSrc"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="midBoxfooter">
      <div class="ImgOrText_footer">
        <div class="ImgOrText_box">
          <p style="font-weight: bold">牧鹿之林</p>
          <p>
            首款三维制作的沉浸式空间社交恋爱软件，全三维打造的场景、家居、角色、宠物，情侣双方可以一起建立自己爱的小屋共筑情感空间提供情
            侣间的情绪价值
          </p>
          <p>
            主要功能有：创建角色、搭建房间、AI学姐、宠物成长、宠物冒险、每日任务、一起看电影，甜言蜜语、恋爱日记、留言板纪念日、心动相册
            每日任务等，打造一个专属的恋爱空间
          </p>
        </div>
      </div>
      <p></p>
    </div>
    <div class="midBoxfooter">
      <img class="allImage aw" :src="muPhoto" alt="" />
    </div>
    <div
      class="midBoxfooter"
      style="
        padding-top: 2%;
        background: linear-gradient(to top, #a2a6ab 0%, #292f38 41%, #1b2128 49%, #161d24 97%);
      "
    >
      <div class="setAllBox" v-for="(v, k) in footerList2" :key="k">
        <div class="por">
          <img
            class="allImage"
            style="height: 100%; overflow: hidden"
            :src="v.src"
            alt=""
          />
        </div>
        <div class="por" style="margin-right: 0px">
          <img
            class="allImage"
            style="height: 100%; overflow: hidden"
            :src="v.otherSrc"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Carousel from "@/components/slideYYZ.vue";
import firstPhoto from "@/assets/metaverse/top.webp";
import changPhoto from "@/assets/metaverse/chang1.webp";
import muPhoto from "@/assets/metaverse/mu01.webp";
import jingPhoto from "@/assets/metaverse/jing.webp";
import Photo1 from "@/assets/metaverse/D4.webp";
import Photo2 from "@/assets/metaverse/D5.webp";
import Photo3 from "@/assets/metaverse/D6.webp";
import footerPhoto1 from "@/assets/metaverse/D1.webp";
import footerPhoto2 from "@/assets/metaverse/D2.webp";
import footerPhoto3 from "@/assets/metaverse/D3.webp";
import XSZG from "@/assets/metaverse/jie01.webp";
import STZG from "@/assets/metaverse/jie02.webp";
import VR from "@/assets/metaverse/jie03.webp";
import VisionPro from "@/assets/metaverse/jie04.webp";
import XSZG2 from "@/assets/metaverse/mu02.webp";
import STZG2 from "@/assets/metaverse/mu04.webp";
import VR2 from "@/assets/metaverse/mu03.webp";
import VisionPro2 from "@/assets/metaverse/mu05.webp";
const footerList = ref([
  {
    src: XSZG,
    otherSrc: STZG,
  },
  {
    src: VR,
    otherSrc: VisionPro,
  },
]);
const footerList2 = ref([
  {
    src: XSZG2,
    otherSrc: STZG2,
  },
  {
    src: VR2,
    otherSrc: VisionPro2,
  },
]);
const imgList = ref([
  { url: Photo1, msg: "D4级" },
  { url: Photo2, msg: "D5级" },
  { url: Photo3, msg: "D6级" },
]);
const firstitems = ref([
  { url: footerPhoto1, msg: "D1级" },
  { url: footerPhoto2, msg: "D2级" },
  { url: footerPhoto3, msg: "D3级" },
]);
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
